import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, getToken, setToken, clearToken } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let active = true;
    // If returning from Google OAuth, let AuthCallback exchange the session first.
    if (window.location.hash?.includes("session_id=")) {
      setReady(true);
      return;
    }
    const token = getToken();
    if (!token) {
      setReady(true);
      return;
    }
    api
      .get("/auth/me")
      .then(({ data }) => active && setUser(data))
      .catch(() => {
        clearToken();
        active && setUser(null);
      })
      .finally(() => active && setReady(true));
    return () => {
      active = false;
    };
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setToken(data.access_token);
    setUser(data.user);
    return data.user;
  }, []);

  const applySession = useCallback((token, nextUser) => {
    setToken(token);
    setUser(nextUser);
  }, []);

  const logout = useCallback(() => {
    api.post("/auth/logout").catch(() => {});
    clearToken();
    setUser(null);
  }, []);

  return <AuthContext.Provider value={{ user, ready, login, logout, applySession }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
